module.exports = __webpack_public_path__ + "static/media/18.fc67de62.jpg";